export default __webpack_public_path__ + "static/media/entertainment.0b1e50c4.jpg";